import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, Subject } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { AppHeaderComponent } from './app-header.component';
import { AuthenticationState } from '@store/reducers';
import { Credential } from '@core/models';
import { selectCredential } from '@store/selectors';
import { LayoutService } from '@layout/service/app.layout.service';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { AUTHENTICATION_CREDENTIAL_SELECTED, CHANGE_ACCOUNT, CHANGE_ACCOUNT_SUCCESS } from '@store/actions';
import { selectChangeAccount } from '@store/selectors';
import { RoleEnum } from '@core/enums';

@Injectable({
  providedIn: 'root',
})
export class AppHeaderPresenter {
  dropdownAccountDataKey = 'idCuenta';
  selectAccount?: Credential;
  changeStore$: Observable<boolean>;
  selectorLanguage: { id: string } = { id: 'english' };
  languages: SelectItem[] = [
    { label: 'EN', value: { id: 'english' } },
    { label: 'ES', value: { id: 'spanish' } },
  ];
  accounts: SelectItem[] = [];
  credential$: Observable<Credential | null>;
  userFullname: string | undefined;
  userRole: string | undefined;
  view!: AppHeaderComponent;

  private destroy$ = new Subject<void>();

  constructor(
    private store: Store<AuthenticationState>,
    public layoutService: LayoutService,
  ) {
    this.credential$ = this.store.select(selectCredential);
    this.changeStore$ = this.store.select(selectChangeAccount);
  }

  setView(view: AppHeaderComponent): void {
    this.view = view;
    this.suscribeObservers();
  }

  onDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  suscribeObservers(): void {
    this.credential$
      .pipe(
        filter((credential): credential is Credential => !!credential),
      )
      .subscribe(({ nombre, isSuperUser, isReseller }) => {
        this.view.userFullname = nombre;
        this.view.userRole = isReseller
        ? RoleEnum.Reseller
        : isSuperUser
          ? RoleEnum.SuperAdmin
          : RoleEnum.Support;
      });

    this.changeStore$
      .pipe(
        filter((changeStore) => !!changeStore),
      )
      .subscribe(() => {
        this.store.dispatch(CHANGE_ACCOUNT_SUCCESS());
        window.location.reload();
      });
  }

  showProfileSidebar(): void {
    this.layoutService.showProfileSidebar();
  }

  changeSelectAccount({ value }: DropdownChangeEvent): void {
    this.store.dispatch(AUTHENTICATION_CREDENTIAL_SELECTED({ credential: value }));
    this.store.dispatch(CHANGE_ACCOUNT());
  }
}
